import { IColumn } from "shared/ui/Table/constants";

export const columns: IColumn[] = [
  {
    label: "ID",
    field: "id",
  },
  {
    label: "name",
    field: "name",
  },
  {
    label: "type",
    field: "typeId",
  },
];
